<template>
  <div class="vp-card-wrap" :style="wrapStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  inject: ['calc'],
  computed: {
    wrapStyle() {
      const { calc } = this;
      return {
        width: calc(660),
        padding: `${calc(26)} ${calc(30)}`,
        ...this.$attrs.style
      };
    }
  }
};
</script>

<style lang="scss">
.vp-card-wrap {
  background: #363532;
  border-radius: 6px;
  box-sizing: border-box;
}
</style>
